import { ConsentText } from "../components";

import type { ConsentFieldFactory } from "./consentFieldFactory.types";

export type {
  ConsentFieldConfig,
  ConsentFieldGetConfigArgs,
  ConsentFieldGetDefaultValueArgs,
  ConsentFieldValue,
} from "./consentFieldFactory.types";

export const consentFieldFactory: ConsentFieldFactory = {
  getDerivedConfig: ({ __, isConsentEnabled }) => {
    return {
      name: "consent",
      labelHtml: <ConsentText />,
      isHidden: !isConsentEnabled,
      registerOptions: {
        required: isConsentEnabled ? __("cart.checkout.consent.required") : false,
      },
    };
  },
  getDefaultValue: ({ defaultChecked = false } = {}) => {
    return defaultChecked;
  },
};
